import React, { useState } from "react";
import logoMyH from "../assets/images/VHU.png";
import { userEvent } from "../controller";

export default function LoginPhone() {
  const [step, setStep] = useState(1); // 1: check phone, 2: register form
  const [phoneNumber, setPhoneNumber] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    donvi: "", // "sinhvien", "tansinhvien", "giangvien", "cuusinhvien"
    mssv: "", // cho sinhvien & tansinhvien
    khoa: "", // cho cuusinhvien (K1 -> K28)
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const khoaKList = Array.from({ length: 28 }, (_, i) => `K${i + 1}`);

  // Check if phone number exists
  const checkPhoneNumber = async () => {
    if (!phoneNumber || phoneNumber.length < 10) {
      setError("Vui lòng nhập số điện thoại hợp lệ");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await userEvent.getUserByPhone({
        phoneNumber: phoneNumber,
        event: "minigameVhu30",
      });

      if (response && response.userEvent) {
        // User exists, login directly
        sessionStorage.setItem("islogged", true);
        sessionStorage.setItem("phoneNumber", phoneNumber);
        sessionStorage.setItem("modeLogin", "phone");
        sessionStorage.setItem("userInfo", JSON.stringify(response));
        localStorage.setItem("islogged", true);
        localStorage.setItem("phoneNumber", phoneNumber);

        window.location.replace("/user/events/");
      } else {
        // User doesn't exist, show registration form
        setStep(2);
      }
    } catch (error) {
      console.error("Error checking phone number:", error);
      // If error (user not found), show registration form
      setStep(2);
    } finally {
      setLoading(false);
    }
  };

  // Create new user account
  const createAccount = async () => {
    if (!formData.name || !formData.donvi) {
      setError("Vui lòng điền đầy đủ thông tin");
      return;
    }

    if (
      (formData.donvi === "sinhvien" || formData.donvi === "tansinhvien") &&
      !formData.mssv
    ) {
      setError("Vui lòng nhập mã số sinh viên");
      return;
    }

    if (formData.donvi === "cuusinhvien" && !formData.khoa) {
      setError("Vui lòng chọn khóa");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const userData = {
        phoneNumber: phoneNumber,
        name: formData.name,
        donvi: formData.donvi,
        role: 0,
        event: "minigameVhu30",
      };

      if (formData.donvi === "sinhvien" || formData.donvi === "tansinhvien") {
        userData.mssv = formData.mssv;
      }

      if (formData.donvi === "cuusinhvien") {
        userData.khoa = formData.khoa;
      }

      const response = await userEvent.createUserPhone(userData);

      if (response) {
        // Account created successfully, login
        sessionStorage.setItem("islogged", true);
        sessionStorage.setItem("phoneNumber", phoneNumber);
        sessionStorage.setItem("modeLogin", "phone");
        sessionStorage.setItem(
          "userInfo",
          JSON.stringify({
            phoneNumber,
            name: formData.name,
            donvi: formData.donvi,
            mssv: formData.mssv || null,
            khoa: formData.khoa || null,
          })
        );
        localStorage.setItem("islogged", true);
        localStorage.setItem("phoneNumber", phoneNumber);

        window.location.replace("/user/events/");
      }
    } catch (error) {
      console.error("Error creating account:", error);
      setError("Có lỗi xảy ra khi tạo tài khoản. Vui lòng thử lại.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setError("");
  };

  return (
    <div className="bg-[#f6f6f6] w-full h-screen flex justify-center items-center p-2">
      <div className="shadow-lg rounded p-10 bg-white max-w-md w-full">
        <img src={logoMyH} alt="Logo" className="w-24 mx-auto mb-6" />

        {step === 1 ? (
          // Step 1: Phone number check
          <>
            <h2 className="text-xl font-bold text-center text-gray-700 mb-6">
              Đăng nhập bằng số điện thoại
            </h2>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Số điện thoại
              </label>
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Nhập số điện thoại của bạn"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                disabled={loading}
              />
            </div>

            {error && (
              <div className="mb-4 text-red-500 text-sm text-center">
                {error}
              </div>
            )}

            <button
              onClick={checkPhoneNumber}
              disabled={loading || !phoneNumber}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Đang kiểm tra..." : "Tiếp tục"}
            </button>
          </>
        ) : (
          // Step 2: Registration form
          <>
            <h2 className="text-xl font-bold text-center text-gray-700 mb-6">
              Tạo tài khoản mới
            </h2>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Số điện thoại
              </label>
              <input
                type="tel"
                value={phoneNumber}
                disabled
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100"
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Vai trò <span className="text-red-500">*</span>
              </label>
              <div className="grid grid-cols-2 gap-3">
                <label className="flex items-center text-sm">
                  <input
                    type="radio"
                    name="donvi"
                    value="sinhvien"
                    checked={formData.donvi === "sinhvien"}
                    onChange={(e) => handleInputChange("donvi", e.target.value)}
                    className="mr-2"
                    disabled={loading}
                  />
                  Sinh viên
                </label>
                <label className="flex items-center text-sm">
                  <input
                    type="radio"
                    name="donvi"
                    value="tansinhvien"
                    checked={formData.donvi === "tansinhvien"}
                    onChange={(e) => handleInputChange("donvi", e.target.value)}
                    className="mr-2"
                    disabled={loading}
                  />
                  Tân sinh viên
                </label>
                <label className="flex items-center text-sm">
                  <input
                    type="radio"
                    name="donvi"
                    value="giangvien"
                    checked={formData.donvi === "giangvien"}
                    onChange={(e) => handleInputChange("donvi", e.target.value)}
                    className="mr-2"
                    disabled={loading}
                  />
                  Giảng viên & CBNV
                </label>
                <label className="flex items-center text-sm">
                  <input
                    type="radio"
                    name="donvi"
                    value="cuusinhvien"
                    checked={formData.donvi === "cuusinhvien"}
                    onChange={(e) => handleInputChange("donvi", e.target.value)}
                    className="mr-2"
                    disabled={loading}
                  />
                  Cựu sinh viên
                </label>
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Họ và tên <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
                placeholder="Nhập họ và tên"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                disabled={loading}
              />
            </div>

            {(formData.donvi === "sinhvien" || formData.donvi === "tansinhvien") && (
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Mã số sinh viên <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formData.mssv}
                  onChange={(e) => handleInputChange("mssv", e.target.value)}
                  placeholder="Nhập mã số sinh viên"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={loading}
                />
              </div>
            )}

            {formData.donvi === "cuusinhvien" && (
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Khóa <span className="text-red-500">*</span>
                </label>
                <select
                  value={formData.khoa}
                  onChange={(e) => handleInputChange("khoa", e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={loading}
                >
                  <option value="">-- Chọn Khóa --</option>
                  {khoaKList.map((k) => (
                    <option key={k} value={k}>
                      {k}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {error && (
              <div className="mb-4 text-red-500 text-sm text-center">
                {error}
              </div>
            )}

            <div className="flex gap-3">
              <button
                onClick={() => setStep(1)}
                disabled={loading}
                className="flex-1 bg-gray-500 text-white py-3 px-4 rounded-md hover:bg-gray-600 transition disabled:opacity-50"
              >
                Quay lại
              </button>
              <button
                onClick={createAccount}
                disabled={
                  loading ||
                  !formData.name ||
                  !formData.donvi ||
                  ((formData.donvi === "sinhvien" || formData.donvi === "tansinhvien") && !formData.mssv) ||
                  (formData.donvi === "cuusinhvien" && !formData.khoa)
                }
                className="flex-1 bg-green-600 text-white py-3 px-4 rounded-md hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Đang tạo..." : "Tạo tài khoản"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
